"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSPrimaryComponent = void 0;
const core_1 = require("@angular/core");
const generic_content_service_1 = require("../services/generic.content.service");
const account_service_1 = require("../services/account.service");
const primaryaccount_service_1 = require("../services/primaryaccount.service");
const index_1 = require("../index");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
class CSPrimaryComponent {
    constructor(primaryAccountService, genericContentService, accountService, helperService, modalService) {
        this.primaryAccountService = primaryAccountService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.helperService = helperService;
        this.modalService = modalService;
        this.callAccountInfo = false;
    }
    ngOnInit() {
        this.getAccountStatus();
    }
    getAccountStatus() {
        this.loader = true;
        this.accountService.getAccountDetails(true).subscribe((res) => {
            this.loader = false;
            this.accountStatus = res.accountStatus;
            this.isProspect = res.prospectProfile;
            this.secondary = res.profileType === 'SECONDARY';
            this.preapidFlag = res.advancePayAccount;
            if (this.preapidFlag) {
                this.amountToUnsuspend = res.amountToUnsuspend;
            }
            if (this.secondary) {
                this.getVerificationStatusForPayment();
            }
            if (((this.accountStatus === undefined && !this.isProspect) && !this.preapidFlag)
                || (this.preapidFlag && !this.accountStatus)) {
                this.getTechnicalErrorMessgae();
            }
            else {
                this.accountInfo();
            }
        });
    }
    accountInfo() {
        this.loader = true;
        if (!this.preapidFlag) {
            this.genericContentService.getGenericContent('/generic/instructional/AccountFinal').subscribe((data) => {
                this.primaryCustInfo = data.contentText;
                if (this.hotline || this.pastDue) {
                    this.getAmountToUnsuspend();
                }
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
        else if (this.preapidFlag) {
            this.genericContentService.getGenericContent('genericPrepaidAccountFinal').subscribe((data) => {
                this.primaryCustInfo = data.contentText;
                if (this.hotline || this.pastDue) {
                    this.getAmountToUnsuspend();
                }
                else {
                    this.unsuspendAmount = this.amountToUnsuspend;
                }
                this.loader = false;
            }, (err) => {
                this.error = err;
                this.loader = false;
            });
        }
    }
    getAmountToUnsuspend() {
        this.primaryAccountService.getAmounttoUnsuspned()
            .subscribe((amount) => {
            this.unsuspendAmount = amount.amountToUnsuspend;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    toAddfunds() {
        if (this.secondary && !this.isLastFourVerified) {
            this.openModal(this.verifyCustomerTemplate);
        }
        else {
            this.helperService.onNavigate('/my_account/personal/#/prepaid/addfunds');
        }
    }
    getTechnicalErrorMessgae() {
        this.accountService.getCSErrorMessage().subscribe((errors) => {
            this.techinalError = errors.technicalDifficulty;
        });
    }
    openModal(content) {
        this.modelError = null;
        this.modelRef = this.modalService.open(content, { size: 'sm', windowClass: 'dark-modal' });
    }
    verifyCustomer(formData, customerType) {
        this.modelError = null;
        this.verifyCustomerLoader = true;
        this.accountService.verifyCustomer(formData.SSN).subscribe((res) => {
            this.modelRef.close();
            if (customerType.toLowerCase() === 'prepaid') {
                this.helperService.onNavigate('/my_account/personal/#/prepaid/addfunds');
            }
            else {
                this.helperService.onNavigate('/my_account/personal/#/wireless/billing/paybill');
            }
        }, (err) => {
            this.modelError = err;
            this.verifyCustomerLoader = false;
        });
    }
    getVerificationStatusForPayment() {
        this.loader = true;
        this.accountService.getPaymentAuthStatus().subscribe((res) => {
            this.isLastFourVerified = res;
            this.loader = false;
        }, (err) => {
            this.loader = false;
        });
    }
    /**
     * Determines if the pressed key is a number key or the backspace or delete key.
     *
     * @param {Object} event - The event object containing the keyCode.
     * @return {boolean} Returns true if the keyCode is a number key or the backspace or delete key, otherwise returns false.
     */
    isNumberKey(event) {
        const { keyCode } = event;
        const isBackspaceOrDelete = (keyCode === 8 || keyCode === 46);
        const isNumberKey = (keyCode >= 48 && keyCode <= 57);
        return isBackspaceOrDelete || isNumberKey;
    }
    /*
     * Sanitizes input to only allow numbers.
     * @param {KeyboardEvent} e - The keyboard event.
     * @returns {void}
     */
    sanitizeInput(event) {
        const inputElement = event.target;
        inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
    }
}
exports.CSPrimaryComponent = CSPrimaryComponent;
//# sourceMappingURL=primaryaccount.component.js.map